/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SimpleHorse } from '../models/SimpleHorse';
import { HttpFile } from '../http/http';

export class WorldCupHorse {
    'horse': SimpleHorse;
    'rider': string;
    'trainer': string;
    'skopulag': number;
    'haefileikar': number;
    'adaleinkunn': number;
    'domurId': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "horse",
            "baseName": "horse",
            "type": "SimpleHorse",
            "format": ""
        },
        {
            "name": "rider",
            "baseName": "rider",
            "type": "string",
            "format": ""
        },
        {
            "name": "trainer",
            "baseName": "trainer",
            "type": "string",
            "format": ""
        },
        {
            "name": "skopulag",
            "baseName": "skopulag",
            "type": "number",
            "format": "double"
        },
        {
            "name": "haefileikar",
            "baseName": "haefileikar",
            "type": "number",
            "format": "double"
        },
        {
            "name": "adaleinkunn",
            "baseName": "adaleinkunn",
            "type": "number",
            "format": "double"
        },
        {
            "name": "domurId",
            "baseName": "domurId",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return WorldCupHorse.attributeTypeMap;
    }

    public constructor() {
    }
}

